import React from "react";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import classnames from "classnames";
import { Tooltip } from "@my-scoot/component-library-legacy";
import { FOOTER_DATA_ITEM_TOOLTIPS } from "../EmailListItem.constants";

const FooterDataItem = ({ data, title, titleClassName, dataClassName }) => {
  const tooltipText = FOOTER_DATA_ITEM_TOOLTIPS[title];

  return (
    <div>
      <div
        className={classnames(
          "tw-text-[14px] tw-font-medium tw-mb-1",
          titleClassName
        )}
      >
        {title}
      </div>

      <div className="tw-flex tw-flex-row tw-items-center tw-gap-1">
        <div
          className={classnames("tw-text-[18px] tw-font-bold", dataClassName)}
        >
          {data}
        </div>

        {tooltipText && (
          <Tooltip arrow color="primary" placement="top" title={tooltipText}>
            <InfoIcon style={{ fontSize: "16px", color: "#A6A6A6" }} />
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default FooterDataItem;
